import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { componentOverrides } from 'themes/componentOverrides';
import { buildGlassSurfaces, buildPalette, radius } from 'themes/tokens';
import { brandLight } from './tokens/brand';
import typography from './typography';

/**
 * InstaView light theme.
 *
 * Every colour is derived from the eleven base hexes in tokens/brand.ts —
 * brand, surfaces, text, borders and the four product sub-palettes all come
 * out of the generated tonal ramps.
 */
export const lightPalette = buildPalette(brandLight, 'light', {
  // Page background is the Home tint, per the token sheet.
  surfaceFrom: 'home'
});

const instaviewCoreTheme = createTheme({
  palette: {
    ...lightPalette,
    glass: buildGlassSurfaces(lightPalette.primary.main)
  },
  radius,
  typography,
  components: componentOverrides
});

export default responsiveFontSizes(instaviewCoreTheme);
